// extracted by mini-css-extract-plugin
export var menuIcon = "_tm-0";
export var menuIconInline = "_tm-1";